<template>
    <edit-view-base :filter="filter" :has-card-view="true" :cards="cards" :tabs="tabs" :main-form="mainForm" :claim-name="claimName" :api-method="apiMethod" :item-id="itemId" :refresh-key="refreshKey" />
</template>

<script>
    export default {
        props: [
            'filter',
            'itemId',
            'refreshKey'
        ],

        components: {
            editViewBase: () => import('../components/EditViewBase')
        },

        data() {
            return {
                cards: [
                    { title: 'Internal Member Audit', apiMethod: 'InternalMemberAudits', form: () => import('../forms/InternalMemberAuditForm'), items: [], filter: {}, dialog: false, isVisible: true, isMainCard: true },
                    { title: 'Internal Corrective Action Request', apiMethod: 'InternalCorrectiveActionRequests', parentForeignKey: 'internalMemberAuditId', form: () => import('../forms/InternalCorrectiveActionRequestForm'), items: [], filter: {}, dialog: false, isVisible: true },
                ],
                tabs: [
                    { text: 'Internal Corrective Action Requests', value: 'internalMemberAuditId', isCard: true, table: () => import('../tables/InternalCorrectiveActionRequestsTable') },
                ],
                mainForm: () => import('../forms/InternalMemberAuditForm'),
                claimName: 'InternalMemberAudits',
                apiMethod: 'InternalMemberAudits',
            }
        }
    };
</script>
